import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageSecurityService {
    // A static key for obfuscation. In a real scenario, this could be environment-dependent.
    // This is sufficient to prevent casual inspection in DevTools.
    private readonly SECRET_KEY = 'colorfol_secure_storage_key_v1';

    constructor() { }

    /**
     * Encrypts a string value using XOR + Base64
     */
    encrypt(value: string): string {
        if (!value) return '';
        try {
            const xor = this.xorMessage(value, this.SECRET_KEY);
            return btoa(xor);
        } catch (e) {
            console.error('Encryption error', e);
            return value;
        }
    }

    /**
     * Decrypts a string value using Base64 + XOR
     */
    decrypt(value: string): string {
        if (!value) return '';
        try {
            const decoded = atob(value);
            return this.xorMessage(decoded, this.SECRET_KEY);
        } catch (e) {
            // If decryption fails (e.g. invalid base64 or legacy plain data), return original
            // This helps with migration if data was previously unencrypted
            return value;
        }
    }

    /**
     * Simple XOR cipher
     */
    private xorMessage(message: string, key: string): string {
        let result = '';
        for (let i = 0; i < message.length; i++) {
            result += String.fromCharCode(message.charCodeAt(i) ^ key.charCodeAt(i % key.length));
        }
        return result;
    }
}
